export const getAuthToken = async ({ clientId, clientSecret, grantType = "client_credentials", tokenUrl }) => {
    if (!tokenUrl) {
        console.error(" Error: `tokenUrl` no está definido.");
        return null;
    }

    const body = new URLSearchParams({
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: grantType
    });

    try {
        const response = await fetch(tokenUrl, {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString(),
        });

        if (!response.ok) {
            throw new Error(`Error obteniendo el token: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data.access_token;
    } catch (error) {
        console.error(" Error en getAuthToken:", error);
        return null;
    }
};
